import React from 'react';
import { Link } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import Badge from '@mui/material/Badge';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import useTelemetry from '@monorepo/shared/src/hooks/use-telemetry';
import {
  ApplicationSection,
  ApplicationTab,
} from '@monorepo/shared/src/graph/schema-generated-types-educator';
import { TelemetryEvents } from '@monorepo/shared/src/types';
import TabHeading from 'components/common/TabHeading';
import useResources from '@monorepo/shared/src/hooks/use-resources';

const t = (key: string, options?) => translate('resources', key, options);

type Props = {
  isSelected?: boolean;
};

type StylesProps = {
  amount: number;
  isSelected: boolean;
};

const PinnedResourcesTabHeading: React.FC<Props> = ({ isSelected = false }) => {
  const [, { fireEvent }] = useTelemetry(TelemetryEvents.VIEW_TAB);
  const [
    {
      pinActions: { amount },
    },
  ] = useResources();

  const classes = useStyles({ amount, isSelected });

  const createTelemetryEvent = () => {
    fireEvent({
      section: ApplicationSection.RESOURCES,
      tab: ApplicationTab.PINNED_RESOURCES,
    });
  };

  return (
    <TabHeading>
      <Link
        to="/resources/pinned-resources"
        className={classes.link}
        onClick={createTelemetryEvent}
      >
        <Badge
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          badgeContent={Math.abs(amount)}
          classes={{ badge: classes.badge }}
        >
          <h2 className={classes.h2}>{t('pinnedResourcesTabHeading')}</h2>
        </Badge>
      </Link>
    </TabHeading>
  );
};

const useStyles = makeStyles((theme: any) => ({
  badge: {
    color: theme.palette.background.paper,
    backgroundColor: (props: StylesProps) =>
      props.amount >= 0 ? theme.palette.success.main : theme.palette.error.main,
    right: '-10px',
    top: '15px',
  },
  h2: {
    color: ({ isSelected }: Props) =>
      isSelected ? (theme.palette as any).black.main : (theme.palette as any).grey[600],
    margin: '0px',
  },
  link: { height: '60px', lineHeight: '60px', width: '100%' },
}));

export default PinnedResourcesTabHeading;
